//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PID.js";
import "../Gateway/Gateway.IGenericFileNewApplicationBuilder.js";
import "../no/FileNew.js";
import "../no/PartTypes.js";
import "../no/Part.js";
import "../no/CollaborativeDesign.js";
import "../no/Assemblies.js";
let d=[[[0,"DisplayPartOption",1,0],[0,"TemplateBaseTcType",1,0],[0,"TemplateFileName",1,0],[0,"TemplatePresentationName",1,0],[0,"TemplateTcType",1,0],[0,"TemplateType",1,0],[0,"TemplateUnits",1,0]],[[[],"GetCollaborativeDesign",{R_:{collaborativeDesign:"CollaborativeDesign"}},0,0],[["collaborativeDesign"],"SetCollaborativeDesign",{},1,0],[["n_partitions"],"GetTargetPartitions",{R_:{partitions:"Assemblies.Partition[]"}},0,0],[["partitions"],"SetTargetPartitions",{},1,0]],[]];
SPLM.PID.FileNewApplicationBuilder = class extends SPLM.Gateway.IGenericFileNewApplicationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PID.FileNewApplicationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;